import { Tooltip } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import useTranslations from '../../../hooks/useTranslations';

import './DefaultIndicator.scss';

interface IDefaultIndicatorProps {
  isDefault?: boolean;
  subscriptionModelName?: string;
  className?: string;
}

const DefaultIndicator = ({
  isDefault = false,
  subscriptionModelName = '',
  className = '',
}: IDefaultIndicatorProps) => {
  const { rcTranslate } = useTranslations();

  if (!isDefault) return null;

  const tooltipText = subscriptionModelName
    ? rcTranslate('pricingPlans.defaultIndicator.tooltipWithModel', [
        { label: 'subscriptionModel', value: subscriptionModelName },
      ])
    : rcTranslate('pricingPlans.defaultIndicator.tooltip');

  return (
    <Tooltip title={tooltipText} arrow placement="top">
      <StarIcon className={`defaultIndicator ${className}`} />
    </Tooltip>
  );
};

export default DefaultIndicator;